import {Box} from '@chakra-ui/react';
import {MenuItemBody} from 'components/shared/profile/components/profile-menu-list/components/menu-item-body';
import {FC} from 'react';

import {NotificationsBell} from '../../../notifications-bell';

interface IProps {
  icon: string;
  title: string;
  onClick: () => void;
  needAuth: boolean;
  orderCount: number;
  isLoggedIn: boolean;
}

export const OrdersMobileWithNotification: FC<IProps> = (item) => {
  const {orderCount, isLoggedIn} = item;

  if (item.needAuth && !isLoggedIn) return null;

  return (
    <Box position="relative" mt="10px">
      <MenuItemBody {...item}>
        {orderCount > 0 && <NotificationsBell boxProps={{right: '-15px', top: '-5px'}} count={orderCount} />}
      </MenuItemBody>
    </Box>
  );
};
